module.exports = __webpack_public_path__ + "media/favicon/mstile-144x144-99bf1182.png";